import type { Rule } from 'antd/lib/form';

const validator = (_: unknown, value?: Array<unknown | null>) => {
  if (value && !value[0] && value[1]) {
    return Promise.reject(new Error('Please select start date'));
  }
  if (value && value[0] && !value[1]) {
    return Promise.reject(new Error('Please select end date'));
  }
  return Promise.resolve();
};

export const RULES: Record<string, Rule[]> = {
  ACTIVE: [{ validator }],
  EXPECTED: [{ validator }],
  CREATED: [{ validator }],
};
